var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: `${_vm.width}px`, height: `${_vm.height}px`})},[_c('iframe',{attrs:{"src":"https://cdn.lottielab.com/l/9o9nCCH8VYMQdq.html","frameborder":"0","width":"100%","height":"100%","allow":"autoplay","title":"No Brand Results Animation"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }